import { useQuery } from '@tanstack/react-query';
import { fetchTestCaseByLoggedInUser } from '../../../../../modules/dashboard';
import Widget from './Widget';
const TestCasesByUser = ({ projectId, isAdmin }) => {
  const { data, isLoading } = useQuery({
    queryKey: [`testCasesByUser`, projectId],
    queryFn: () => fetchTestCaseByLoggedInUser(projectId, isAdmin),
    enabled: !!projectId && isAdmin !== undefined,
  });

  return (
    <div>
      <Widget
        title={isAdmin ? 'No. of Test Cases' : 'TCs Authored by You'}
        body={data?.data}
        loading={isLoading}
      />
    </div>
  );
};

export default TestCasesByUser;
